import axios from 'axios';
import jsonpAdapter from 'axios-jsonp';

export default class {
  #news = {
    date: '',
    body: '',
    title: '',
    url: '',
  };
  #id = '';
  id = '';

  get badge() {
    if (!this.id) return false;
    return this.id !== this.#id;
  }

  init(params) {
    return axios({
      url: 'https://www.mag.travel/news_widget/',
      adapter: jsonpAdapter,
    })
      .then(({ data }) => {
        this.#id = params.OwnReadNewsIds || '';
        this.id = data.hash_ids.replace(/\./g, ',');
        const items = data.messages.map((i) => {
          const arr = i.date.split('.') || [];
          const date = new Date(+(`20${arr[2]}`), (arr[1] - 1), +arr[0]);
          return {
            label: i.subject,
            value: i.id,
            link: i.url,
            date,
            type: 'Mag',
          };
        });

        let availableNews = data.messages.filter(i => !~this.#id.split(',').map(j => +j).indexOf(+i.id));

        if (availableNews && availableNews.length) {
          this.#news = {
            date: data.messages[0].date_rss,
            body: data.messages[0].short,
            title: data.messages[0].subject,
            url: data.messages[0].url,
          };
          return {
            items,
            news: this.#news,
          };
        } else {
          return {
            items
          }
        }
      });
  }

  getNews() {
    return Promise.resolve(this.#news);
  }

  read() {
    if (this.id === this.#id) {
      return Promise.resolve();
    }
    return axios
      .post('/tourclient/account/SetNewsRead', `ids=${this.id}&ownNews=true`)
      .then(() => {
        this.#id = this.id;
      });
  }
}
